import { GetHeader, PPHeader } from "../common"

const URL = process.env.REACT_APP_API_MASTER!

export interface typeCategory {
  filter(arg0: boolean): any;
  categoryClsCd: string,
  categoryCd: string,
  localeId: string,
  categoryName: string,
}

export interface typeMemberList {
  userCd: string,
  termCd: string,
  startDate: string,
  endDate: string,
  telephoneNumber: string,
  mobileNumber: string | null,
  faxNumber: string | null,
  extensionNumber: string | null,
  extensionFaxNumber: string | null,
  countryCd: string | null,
  zipCode: string | null,
  emailAddress1: string | null,
  emailAddress2: string | null,
  mobileEmailAddress: string | null,
  url: string | null,
  localeId: string | null,
  userName: string,
  userNameSyllabary: string | null,
  userNameEng: string | null,
  address: string | null,
  companyCd: string,
  departmentCd: string,
  departmentName: string | null,
  departmentNameSyllabary: string | null,
  departmentNameEng: string | null,
  address1: string | null,
  address2: string | null,
  notes: string | null
}

export interface typeMember {
  userCd: string,
  userName: string,
  emailAddress1: string,
  telephoneNumber: string,
  faxNumber: string,
  departmentName: string,
  post: string,
  url: boolean,
}
//007 分類設定一覧取得サービス 完了
export const getCategory = async (categoryClsCd: string, userid: string, token: string, role: string): Promise<typeCategory[]> => {
  const header = GetHeader(userid, token, role)
  const res = await fetch(`${URL}/category/${categoryClsCd}`, header).then(response => {
    if (response.status === 204) {
      return []
    } else if (response.ok) {
      return response.json()
    } else {
      throw response
    }
  })
  return res
}

//008 メンバー情報一覧取得サービス 完了
export const getMemberList = async (userid: string, tokenUser: string, token: string, role: string): Promise<typeMemberList[]> => {
  const header = GetHeader(tokenUser, token, role)
  const res = await fetch(`${URL}/members/${userid}`, header).then(response => {
    if (response.status === 204) {
      return []
    } else if (response.ok) {
      return response.json()
    } else {
      throw response
    }
  })
  return res
}

//009 メンバー情報取得サービス 完了
export const getMember = async (userid: string, token: string, role: string, usercd: string):Promise<typeMemberList> => {
  const header = GetHeader(userid, token, role)
  const res = await fetch(`${URL}/member/${usercd}`, header).then(response => {
    if (response.status === 204) {
      return []
    } else if (response.ok) {
      return response.json()
    } else {
      throw response
    }
  })
  return res
}

//010 メンバー情報登録サービス 完了
export const postMember = async (userid: string, token: string, role: string, form: typeMember) => {
  //form to JSON userCdをuserIdに変更する
  let obj = {}
  for (const [key, value] of Object.entries(form)) {
    if (key === 'url') {
      if (value) {
        obj[key] = '○'
      } else {
        obj[key] = null
      }
    } else {
      obj[key] = value
    }
  }
  obj['userId'] = userid
  delete obj['userCd']
  let jsondata = JSON.stringify(obj)
  const header = PPHeader(userid, token, role, jsondata, 'POST')
  const res = await fetch(`${URL}/member`, header).then(response => {
    if (response.ok) {
      return response.ok
    } else {
      throw response
    }
  })
  return res
}


//011 メンバー情報更新サービス 完了
export const updateMember = async (userid: string, token: string, role: string, form: typeMember) => {
  //form to JSON
  let obj = {}
  for (const [key, value] of Object.entries(form)) {
    if (key === 'url') {
      if (value) {
        obj[key] = '○'
      } else {
        obj[key] = null
      }
    } else {
      obj[key] = value
    }
  }
  let jsondata = JSON.stringify(obj)
  const header = PPHeader(userid, token, role, jsondata, 'PUT')
  const res = await fetch(`${URL}/member/${form.userCd}`, header).then(response => {
    if (response.ok) {
      return response.ok
    } else {
      throw response
    }
  })
  return res
}